import { appendPath, getValue } from '@truqc/content-path';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal, ModalBody, ModalFooter, Button } from 'reactstrap';
import { enabledSelector, newPathSelector, titleSelector } from '../selectors/index';
import entityComposition from '../../common/classes/entityComposition';
import { getContent } from '../selectors/simpleSelectors';
import { convertToAbsolutePath } from '../utils';
const parseTitleCount = (titleCount, content, path) => {
  const {
    countContentPath,
    templates
  } = titleCount;
  const countPath = appendPath(path, countContentPath);
  const value = getValue(countPath, content) || {};
  const nonNullValues = Object.values(value).filter(val => val !== null);
  const count = nonNullValues.length || 0;
  const template = templates[count] || templates[''];
  return template.replace(/#/g, count);
};
class ModalButton extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false
    };
    this.handleOpen = this.handleOpen.bind(this);
    this.handleClose = this.handleClose.bind(this);
  }
  invokeActions(actions) {
    const {
      parentContentPath,
      reportActions,
      formActions,
      issueActions,
      reduxEntity,
      variables
    } = this.props;
    let {
      handleActions
    } = reportActions;
    if (reduxEntity === 'form') {
      ({
        handleActions
      } = formActions);
    } else if (reduxEntity !== 'issue') {
      ({
        handleActions
      } = issueActions);
    }
    if (actions.length > 0) {
      handleActions(reduxEntity, actions, parentContentPath, variables);
    }
  }
  handleOpen() {
    const {
      preActions
    } = this.props;
    this.invokeActions(preActions);
    this.setState({
      isOpen: true
    });
  }
  handleClose() {
    const {
      postActions
    } = this.props;
    this.invokeActions(postActions);
    this.setState({
      isOpen: false
    });
  }
  render() {
    const {
      content,
      enabled,
      format,
      parentContentPath,
      title,
      children
    } = this.props;
    const {
      contentPath,
      titleCount
    } = format;
    const absolutePath = convertToAbsolutePath(contentPath, parentContentPath);
    // if format.contentPath, use parentPath to reference the corrected path for countContentPath
    const buttonText = titleCount ? parseTitleCount(titleCount, content, absolutePath) : title;
    const {
      isOpen
    } = this.state;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Modal, {
      isOpen: isOpen,
      style: {
        maxWidth: '800px'
      }
    }, /*#__PURE__*/React.createElement(ModalBody, null, children), /*#__PURE__*/React.createElement(ModalFooter, null, /*#__PURE__*/React.createElement(Button, {
      onClick: this.handleClose,
      className: "t-am-cancel"
    }, "Done"))), /*#__PURE__*/React.createElement(Button, {
      block: true,
      onClick: this.handleOpen,
      disabled: !enabled,
      className: "t-rb-add-button tqc-control modal-button"
    }, buttonText));
  }
}
ModalButton.defaultProps = {
  children: {},
  parentContentPath: '/',
  postActions: [],
  preActions: [],
  title: '',
  transientContext: {},
  variables: {}
};
ModalButton.propTypes = {
  children: PropTypes.node,
  content: PropTypes.shape({
    id: PropTypes.string,
    formType: PropTypes.shape({}),
    issueType: PropTypes.shape({})
  }).isRequired,
  enabled: PropTypes.bool.isRequired,
  formActions: PropTypes.shape({
    handleActions: PropTypes.func
  }).isRequired,
  format: PropTypes.shape({
    contentPath: PropTypes.string,
    titleCount: PropTypes.shape({
      templates: PropTypes.shape({}).isRequired,
      countContentPath: PropTypes.string.isRequired
    })
  }).isRequired,
  issueActions: PropTypes.shape({
    handleActions: PropTypes.func
  }).isRequired,
  parentContentPath: PropTypes.string,
  preActions: PropTypes.arrayOf(PropTypes.shape({})),
  postActions: PropTypes.arrayOf(PropTypes.shape({})),
  reduxEntity: PropTypes.string.isRequired,
  reportActions: PropTypes.shape({
    handleActions: PropTypes.func
  }).isRequired,
  title: PropTypes.string,
  transientContext: PropTypes.shape({}),
  variables: PropTypes.shape({})
};
export { ModalButton as UncomposedModalButton };
export default entityComposition(ModalButton, [], {
  enabled: enabledSelector,
  title: titleSelector,
  path: newPathSelector,
  content: getContent
}, ['report', 'form', 'issue']);